import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type { AutoFocusTarget } from '@angular/cdk/dialog';
import { HlmSheet } from '../helm/sheet/src/lib/hlm-sheet';
import { BrnSheetContent } from '@spartan-ng/brain/sheet';
import { HlmSheetPortal } from '../helm/sheet/src/lib/hlm-sheet-portal';
import { HlmSheetContent } from '../helm/sheet/src/lib/hlm-sheet-content';

type UiSheetSide = 'top' | 'bottom' | 'left' | 'right';
type UiSheetState = 'open' | 'closed';

@Component({
    selector: 'app-ui-sheet-shell',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './sheet-shell.component.html',
    imports: [
        HlmSheet,
        BrnSheetContent,
        HlmSheetPortal,
        HlmSheetContent,
    ],
})
export class UiSheetShellComponent {
  readonly open = input(false);
  readonly side = input<UiSheetSide>('right');
  readonly ariaLabel = input('Sheet');
  /**
   * Id of a visible title inside the sheet. When set it names the sheet and `ariaLabel` is
   * omitted, because the CDK dialog container ignores `aria-labelledby` while a label is set.
   */
  readonly ariaLabelledBy = input<string | null>(null);
  readonly hasBackdrop = input(true);
  readonly closeOnBackdropClick = input(true);
  readonly closeOnOutsidePointerEvents = input(true);
  readonly showCloseButton = input(true);
  readonly contentClass = input('');
  readonly overlayClass = input('');
  readonly autoFocus = input<AutoFocusTarget | string | boolean>('dialog');

  readonly closed = output<unknown>();

  readonly state = computed<UiSheetState>(() => (this.open() ? 'open' : 'closed'));
}
